module.exports = __webpack_public_path__ + "d54d458399d65595e5511129e15c4415.woff2";